import { useNavigate } from "react-router-dom";
import { useLocation } from "react-use";
import { close_drawer } from "state/actions";
import { getFocus, useAtom, useGet } from "state/jotai";
import { _bootstrap } from "state/store.bootstrap";
import { active_project, current_language, isMulti_project_active, params_query, vis_desktop_nav, vis_filter } from "state/store.global";
import { useSendClick } from "./fetch/useSendClick";
import { useBreak } from "./useBreak";
import { useToggle } from "./useToggle";

export const useDualMenuLogic = () => {

  const { toggleOverlay } = useToggle();

  const navigate = useNavigate();
  const here = useLocation().pathname;

  const { pin, pid } = useGet(active_project);
  const type = getFocus(_bootstrap, "type");
  const names = getFocus(_bootstrap, "projectnames");

  const currentLanguage = useAtom(current_language)[0];
  const params = useGet(params_query);

  const [, setShowMenu] = useAtom(vis_desktop_nav);
  const [, setShowFilter] = useAtom(vis_filter);
  const setMultiActive = useAtom(isMulti_project_active)[1];
  const closeDrawer = useAtom(close_drawer)[1];

  const sendClick = useSendClick();

  const isMobile = useBreak("md_dn");
  const isIsometry = here.includes("isometry");

  const clickList = () => {
    toggleOverlay('')
    setShowFilter(false);
    setShowMenu(false);
    setMultiActive(pin > 0);
    sendClick("unit_list_button");

    navigate(`/${currentLanguage}/list${params || ""}`);
  };

  const clickModel = () => {
    if (pin === 0) toggleOverlay("");

    setShowFilter(false);
    setShowMenu(false);
    sendClick(type === "poly" && pin === 0 ? "overview" : "model_button");

    navigate(
      type === "mono"
        ? `/${currentLanguage}/isometry${params || ""}`
        : `/${currentLanguage + names[currentLanguage][pin].path}${params || ""}`
    );
  };

  return {
    pin,
    pid,
    type,
    isMobile,
    isIsometry,
    clickList,
    clickModel
  };
};